import { LoadingButton, LoadingButtonProps } from '@mui/lab'
import { useEffect, useState } from 'react'

interface DelayedLoadingButtonProps extends LoadingButtonProps {
  loadingIndicatorDelayMs?: number
}

export default function DelayedLoadingButton({
  disabled,
  loading = false,
  loadingIndicatorDelayMs = 1_000,
  ...buttonProps
}: DelayedLoadingButtonProps) {
  const [showLoadingIndicator, setShowLoadingIndicator] = useState(false)

  useEffect(() => {
    setShowLoadingIndicator(false)

    if (!loading) {
      return
    }

    const timeout = window.setTimeout(() => {
      setShowLoadingIndicator(true)
    }, loadingIndicatorDelayMs)

    return () => {
      window.clearTimeout(timeout)
    }
  }, [loading, loadingIndicatorDelayMs])

  return (
    <LoadingButton
      {...buttonProps}
      disabled={disabled || Boolean(loading)}
      loading={Boolean(loading) && showLoadingIndicator}
    />
  )
}
